



















import { Observer } from 'mobx-vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Observer
@Component
export default class extends Vue {
  @Prop({ default: 48 }) size!: number
  @Prop({ default: 'SB' }) farmType!: string

  logos = ['logo-SB.png', 'usdt-logo.png']

  @Watch('farmType', { immediate: true }) async onTypeChange(val) {
    if (val === 'STE') {
      this.logos = ['logo-STE.png', 'usdt-logo.png']
    }
  }
}
